var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"ACADEMIC SERVICES","title":"Examination and Assessment","description":"Set up examinations and manage marks, attendance and student assessments.","count-label":"assessment tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }